import React, { useState, useEffect } from 'react';
import { Swipeable } from 'react-swipeable';
import { applyTransition, } from '@nykaa/deals-utils/slider';
import styled from '../../theme';
const SlidesContainer = styled.div `
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  overflow-x: ${({ isDesktop }) => (isDesktop ? 'hide' : 'scroll')};
  overflow-y: hide;
  -webkit-overflow-scrolling: touch;
  &.disable-scrollbars::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  } 
  .disable-scrollbars {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
`;
const Container = styled.div `
  padding:0px 8px;
`;
const SlideWrapper = styled.div `
  align-items: stretch;
  flex: 0 0 auto;
  display: flex;
  width: ${({ width }) => width}%;
  padding: 0px 10px 10px 0px;
  margin: 0px 2px;
  .titles-description
  {
    padding: 10px 0px;
    white-space: normal;
  }
  @media ${(props) => props.theme.mq.md} { 
    display: inline-block;
  }
`;
const Heading = styled.h2 `
  color: #3f414d;
  font-size: 17px;
  font-weight: bold;
  letter-spacing: normal;
  text-transform: uppercase;
  margin: 10px auto 5px auto;
  max-width: 1140px;
  text-align:${({ textAlign }) => textAlign};
  @media ${(props) => props.theme.mq.md} { 
    font-size: 24px;
    font-weight: normal;
  }
`;
const LeftArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/3df01759-af0c-4d81-b2f7-f61577ac3807.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  left: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
const RightArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/45d5a7b6-86eb-4850-9568-4d6ed91731fe.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  right: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
const SlidingWidget = (widgetData) => {
    const { children, id, isDesktop, params, } = widgetData;
    const { title, titleAlign, childWidth } = params;
    const width = childWidth || '50';
    const [activeSlide, changeSlide] = useState(0);
    const slides = children;
    const slidesLength = slides.length;
    const tilesPerView = Math.floor(100 / Number(width));
    const sliderPerView = slidesLength - tilesPerView + 1;
    const rightClickHandler = () => {
        const newSlide = activeSlide + 1;
        if (newSlide < sliderPerView) {
            changeSlide(newSlide);
        }
    };
    const leftClickHandler = () => {
        const newSlide = activeSlide - 1;
        if (newSlide >= 0) {
            changeSlide(newSlide);
        }
    };
    useEffect(() => {
        applyTransition(activeSlide, id, 0.15);
    }, [activeSlide]);
    return (React.createElement(Container, null,
        title && (React.createElement(Heading, { textAlign: titleAlign }, title)),
        React.createElement(Swipeable, { delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: false, trackMouse: false, rotationAngle: 0, style: {
                height: '90%',
                maxWidth: '1140px',
                margin: '0px auto',
                position: 'relative',
            } },
            React.createElement(SlidesContainer, { className: "disable-scrollbars", isDesktop: isDesktop },
                (isDesktop && slidesLength > 1) && React.createElement(LeftArrow, { onClick: leftClickHandler }),
                (isDesktop && slidesLength > 1) && React.createElement(RightArrow, { onClick: rightClickHandler }),
                slides.map((slide) => (React.createElement(SlideWrapper, { width: width, isDesktop: isDesktop, className: id }, slide)))))));
};
export default SlidingWidget;
